import { FC } from 'react';
import styled from '@emotion/styled';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { Button } from 'components/core/button';
import PinkWink from 'public/assets/img/buddies/Pink-HYP-Wink-1X.gif';

import PhoneLink from '../PhoneLink';

export const Bullet = styled.div`
  display: flex;
  min-width: 40px;
  min-height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background: #d3f0f0;
`;

interface AspSignUpConfirmationProps {
  handleGoBack: () => void;
}

const AspSignUpConfirmation: FC<AspSignUpConfirmationProps> = ({
  handleGoBack,
}) => {
  return (
    <div className="flex mx-auto lg:w-[800px] w-full flex-col px-5 mb-10 lg:mb-0">
      <div className="flex items-center flex-col lg:flex-row">
        <div className="order-1 lg:order-last">
          <img
            src={PinkWink}
            className="h-28 w-28 lg:h-32 lg:w-36 rounded-full object-cover"
          />
        </div>
        <div className="flex flex-col w-full order-last lg:order-first lg:items-start items-center lg:text-left mt-6 lg:mt-0">
          <Text variant="h3" className="text-[#078189]">
            Thank you!
          </Text>
          <Text variant="body-2">We will reach out to you shortly.</Text>
        </div>
      </div>
      <div className="my-8">
        <Text variant="body-4">
          In the meantime, secure your child&apos;s enrollment by filling out
          our required consent and policy forms:
        </Text>
        <ul className="list-disc pl-5">
          <li>
            <a
              href="https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=f24f36eb-2db5-4e9c-8a53-6fb769404359&env=na4&acct=4d0a38e7-7ff4-4ae8-a82a-d5cb30aeb193&v=2"
              target="_blank"
              className="font-semibold cursor-pointer text-[#018847]"
              rel="noreferrer"
            >
              Terms, Conditions and Consent
            </a>
          </li>
          <li>
            <a
              href="https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=df116c60-1064-474f-b0c2-31bb46c6d17e&env=na4&acct=4d0a38e7-7ff4-4ae8-a82a-d5cb30aeb193&v=2"
              target="_blank"
              className="font-semibold cursor-pointer text-[#018847]"
              rel="noreferrer"
            >
              Financial Policy
            </a>
          </li>
          <li>
            <a
              href="https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=0236bf2d-97ac-4033-a75d-fb2c61667763&env=na4&acct=4d0a38e7-7ff4-4ae8-a82a-d5cb30aeb193&v=2"
              className="font-semibold cursor-pointer text-[#018847]"
              target="_blank"
              rel="noreferrer"
            >
              Teen Consent
            </a>{' '}
            (for ages 13-17)
          </li>
        </ul>
      </div>

      <div className="pt-8 relative before:absolute before:h-1 before:w-8 before:bg-[#ffafb4] before:top-0 pt-4 mt-2">
        <Text className="!inline pt-8 relative before:absolute before:h-1 before:w-8 before:bg-[#ffafb4] before:top-0 pt-4 mt-8">
          If you have questions or need additional assistance, call&nbsp;
          <PhoneLink phone="(800) 516-0975" />
          &nbsp; for support.
        </Text>
      </div>
      <div className="my-8 mx-auto">
        <Button className="" onClick={handleGoBack}>
          Create Another Request
        </Button>
      </div>
    </div>
  );
};

export default AspSignUpConfirmation;
